import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import DraftStateContext from "../../contexts/draftStateContext";
import useDraftMutations from "../../hooks/queryResults/draft/useDraftMutations";
import styled from "styled-components";
import useDraftSettings from "../../hooks/queryResults/draft/useDraftSettings";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useCurrentUser from "../../hooks/useCurrentUser";
import Loading from "../ui/Loading";

const StyledContainerDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;

  & > button {
    margin: 0.2rem;
  }
`;

export default function Admin() {
  const draftState = useContext(DraftStateContext);
  const {
    hasStarted,
    hasEnded,
    isChoosingSpots,
    isPaused,
    hasFirstPickBeenMade,
    hasLastPickBeenMade,
    pickNumOnClock,
  } = draftState.info;
  const { draftSettingsData, draftSettingsQuery } = useDraftSettings();
  const { league, leagueSeason, leagueQuery } = useLeagueSeason();
  const {
    autoPickMutation,
    endMutation,
    resetDraftMutation,
    startDraftMutation,
    undoChooseSpotMutation,
    undoPickMutation,
    pauseMutation,
    resumeMutation,
  } = useDraftMutations();
  const currentUser = useCurrentUser();
  const history = useHistory();

  const isLoading = useIsLoading(
    draftSettingsData,
    draftSettingsQuery,
    league,
    leagueSeason,
    leagueQuery
  );

  if (isLoading) return <Loading />;

  const isAdmin = currentUser.isAdmin();
  const isLeagueOfficial = currentUser.isLeagueOfficial(league);

  console.log("isLeagueOfficial", isLeagueOfficial);

  if (!isLeagueOfficial) return null;

  const { spots } = draftState;
  const { draftOrder } = draftSettingsData.settings;

  /** @type {?string} teamIdChoosingNow */
  let teamIdChoosingNow = null;
  let teamIdWhoChoseLast = null;
  for (const teamId of draftOrder) {
    if (!spots.includes(teamId)) teamIdChoosingNow = teamId;
    else teamIdWhoChoseLast = teamId;
    if (teamIdChoosingNow) break;
  }

  const confirmReset = () => {
    if (
      window.confirm(
        "Are you sure you want to reset the draft? This can NOT be undone!"
      )
    )
      resetDraftMutation.mutate(null);
  };

  const handleUndoChooseSpot = () => {
    if (teamIdWhoChoseLast)
      undoChooseSpotMutation.mutate({ team: teamIdWhoChoseLast });
  };

  const handleUndoPick = () => {
    if (!hasFirstPickBeenMade) return;

    let pickNum;
    if (hasLastPickBeenMade) {
      pickNum =
        draftSettingsData.settings.numTeams *
        draftSettingsData.settings.numRounds;
    } else {
      pickNum = pickNumOnClock - 1;
    }
    undoPickMutation.mutate({ pickNum });
  };

  let startButton = null,
    pauseOrResumeButton = null,
    undoButton = null,
    autoPickButton = null,
    resetButton = null,
    endButton = null,
    passwordButton = null;

  if (isAdmin) {
    if (!hasStarted) {
      startButton = (
        <button onClick={startDraftMutation.mutate} className={"btn"}>
          Start
        </button>
      );
    }

    if (hasStarted && !isChoosingSpots && !hasEnded)
      autoPickButton = (
        <button
          onClick={() => autoPickMutation.mutate(pickNumOnClock)}
          className={"btn"}
        >
          Auto
        </button>
      );

    resetButton = (
      <button onClick={confirmReset} className={"btn"}>
        Reset
      </button>
    );

    if (!hasEnded && hasLastPickBeenMade)
      endButton = <button className={"btn"} onClick={endMutation.mutate} >End</button>;

    passwordButton = (
      <button
        className={"btn"}
        onClick={() =>
          history.push(
            `/admin/passwords/${league.getIdOrSlug()}/${
              leagueSeason.obj.season
            }`
          )
        }
      >
        Passwords
      </button>
    );
  }

  if (hasStarted && !hasEnded) {
    if (!isChoosingSpots) {
      pauseOrResumeButton = (
        <button
          className={"btn"}
          onClick={() => {
            isPaused ? resumeMutation.mutate(null) : pauseMutation.mutate(null);
          }}
        >
          {isPaused ? "Resume" : "Pause"}
        </button>
      );
    }

    if (teamIdWhoChoseLast) {
      let undoHandler = handleUndoPick;
      if (isChoosingSpots || !hasFirstPickBeenMade)
        undoHandler = handleUndoChooseSpot;

      undoButton = (
        <button onClick={undoHandler} className={"btn"}>
          Undo
        </button>
      );
    }
  }

  return (
    <StyledContainerDiv>
      {startButton}
      {pauseOrResumeButton}
      {autoPickButton}
      {undoButton}
      {resetButton}
      {endButton}
      {passwordButton}
    </StyledContainerDiv>
  );
}
